import { render, staticRenderFns } from "./EditDepartmentComponent.vue?vue&type=template&id=24c2c0b4&scoped=true"
import script from "./EditDepartmentComponent.vue?vue&type=script&lang=js"
export * from "./EditDepartmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2c0b4",
  null
  
)

export default component.exports